<template>
    <div class="AIAssisted-content">
        <div class="block">
            <div class="title">
                <div class="txt">标题（选择标题，输入关键字，多个关键字可以使用英文逗号隔开，点击ai生成）</div>
                <el-button type="primary" @click="getAIData">ai生成</el-button>
            </div>
            <div class="result">
                ai结果: {{ aiResult }} <el-button type="text" icon="el-icon-copy-document" style="padding:0;margin-left: 10px;"
                @click="myCopyText(aiResult)"></el-button>
            </div>
            <div class="row">
                关键字：<el-input v-model="titleKeyWord" placeholder="输入多个关键字请用；分割" clear @input="getRequestWord"/>
            </div>
            <div class="row">
                ai查询话术(根据需要自行修改)：<el-input v-model="aiRequestWord" clear />
            </div>
            <div class="content content1">
                <div v-for="item in data" :key="item.sku">
                    <el-checkbox v-model="item.titleChecked" @change="getRequestWord"></el-checkbox>
                    {{ item.title }}
                    <el-button type="text" icon="el-icon-copy-document" style="padding:0;margin-left: 10px;"
                            @click="myCopyText(item.title)"></el-button>
                </div>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="block">
            <div class="title">描述</div>
            
        </div>
        <div class="content">
            <!-- <div class="btns">
                {{ data.map(item => item.sku) }}
            </div> -->
            <div class="html-contaner">
                <div class="html-content" :id="item.sku" v-for="item, index in data" :key="index" >
                    <div class="tip-row">
                        <div class="txt">sku：{{ item.sku }}</div>
                        <el-button type="text" icon="el-icon-copy-document" @click="myCopyText(item.description)">复制描述</el-button>
                    </div>
                    
                    <div v-html="item.description"></div>
                    <el-divider></el-divider>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { ajaxPost, Baseurl } from '../../../../api/api/api'
    import {copyText} from '@/utils/common';
    import { mapState } from 'vuex';
export default {
    name: 'AIAssisted',
    components: {},
    props: {},
    data() {
        return {
            data: [],
            aiResult: '',
            titleKeyWord: '',
            aiRequestWord: '',
        };
    },
    watch: {},
    computed:{
        ...mapState({
            role: state => state.user.role,
        })
    },
    methods: {
        getRequestWord(){
            const titles = this.data.filter(item => item.titleChecked).map(item => item.title).join('；');
            this.aiRequestWord = "标题[" + titles + "];关键字[" + this.titleKeyWord + "],标题和关键字均使用分号分割,请结合以上几个商品标题和关键字,生成一段精美的标题,标题要求:俄语语言,且不超过300个字符";
        },
        myCopyText(text){
            copyText(text).then(() => {
                this.$message.success('复制成功')
            }).catch(() => {
                this.$message.error('复制失败')
            })
        },
        searchData(params){
            ajaxPost(Baseurl + 'amazonProductCrawl/getPriceAndImageBySearchTerm', params).then((response)=>{
                if (response.status == 200 && response.data && response.data.code == 200) {
                    const data = response.data.data;
                    if(data.length == 0){
                        this.$message.warning('没有查询到数据')
                    }
                    this.data = data;
                }
            })
        },
        getAIData(){
            const params = {
                "rid": this.role.rid,
                "companyId": this.role.company_id,
                "content": this.aiRequestWord
            }
            
            ajaxPost(Baseurl + 'tongYiChat/ozonTitleGeneration', params).then((response)=>{
                if (response.status == 200 && response.data && response.data.code == 200) {
                    this.aiResult = response.data.data
                }
            })
        },
    },
    created() {
        const paramsStr = this.$route.query.params;
        if (paramsStr) {
            try {
                const decodedParams = JSON.parse(paramsStr);
                this.searchData(decodedParams);
                console.log('解析后的参数:', decodedParams);
            } catch (err) {
                
            }
        }
    },

    // 需要设置跟组件的style
    mounted() {
        const app = document.getElementById('app');
        if (app) {
            app.style.overflow = 'auto';
        }
    },
    beforeDestroy() {
        const app = document.getElementById('app');
        if (app) {
            app.style.overflow = ''; // 清空回默认
        }
    }
};
</script>
<style lang="scss" scoped>
.AIAssisted-content{
    padding: 10px;
    .block{
        .title{
            font-size: 18px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .txt{
                margin-right: 10px;
            }
        }
        .content{
            // max-height: 400px;
            // overflow: auto;
            
        }
        .content1{
            max-height: 400px;
            overflow: auto;
            font-size: 16px;
        }
        .result{
            font-size: 16px;
            margin: 5px 0;
            // border: 1px solid #ccc;
            padding: 5px;
            background-color: aqua;
        }
        
    }
}
.html-contaner{
    font-size: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    overflow: auto;
    .html-content{
        width: calc((100% - 40px) / 4);
        max-height: calc(100vh - 100px);
        border: 1px solid #ccc;
        box-sizing: border-box;
        padding: 5px;
        overflow: auto;
        // margin: 0 auto;
        .tip-row{
            display: flex;
            align-items: center;
        }
    }
}
.row{
    display: flex;
    align-items: center;
    font-size: 16px;
    margin: 5px 0;
    .el-input{
        flex: 1;
    }
}


</style>